import React from 'react'

export function AboutUsSrOnly() {
  return (
    <div className={'sr-only'}>
      <h1>About Us | About Ship And Storage</h1>
    </div>
  )
}
